<template>
  <div>
    <v-card flat color="white">
      <v-flex xs12 sm12 md12 lg12>
            <h3 class="pt-3">
              Documents
              <v-btn flat color="primary">
                <v-icon
                  @click="addItem()"
                >add</v-icon>
              </v-btn>
            </h3>
            <v-container>
              <v-data-table
                :headers="documentHeaders"
                class="elevation-1"
                :rows-per-page-items="[5, 10, 25, 50, 100]"
                :items="documents"
                item-key="id"
                align-center
                disable-initial-sort
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                     <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                medium
                class="mr-2"
                @click="editItem(props.item)"
              >edit</v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-icon class="mr-2" medium @click="deleteFile(props.item.id)">delete</v-icon>
                     <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="props.item.base64!==''&&props.item.base64!==null"
                medium
                class="mr-2"
                @click="downloadFile(props.item.id)"
                color="primary"
              >cloud_download</v-icon>
            </template>
            <span>Download</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a target="_blank"
                  :href="props.item.fileUrl"
                   @click.stop
                   v-on="on">                                                    
              <v-icon
                v-on="on"
                v-if="!props.item.base64"
                medium
                class="mr-2"
                color="primary"
              >open_in_new</v-icon>
              </a>
            </template>
            <span>Open Link in New Tab</span>
          </v-tooltip>
                      
                      </td>
                  <td class="text-xs-center">{{props.item.name}}</td>
                  <td class="text-xs-center">{{props.item.description}}</td>
                </template>
                <template
                  v-slot:pageText="props"
                >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
              </v-data-table>
            </v-container>
          </v-flex>

          <v-dialog v-model="uploadFileModal" max-width="750px">
     
      <v-card flat color="white">
         <v-toolbar flat color="primary">
        <h1 class='headline white--text'>ATTACH FILE</h1>
        
      </v-toolbar>
      <v-flex xs12 px-4 mx-4>
      <v-select v-model="uploadType" label="Upload Type" :items="uploadTypes"></v-select>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType==='URL'">
      <v-text-field  label="*File Name" v-model="fileName"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType!==''">
      <v-text-field  label="File Description" v-model="fileDescription"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType==='URL'">
      <v-text-field  label="*File URL" v-model="fileUrl"></v-text-field>
      </v-flex>
      <br/>
        <input v-if="uploadType==='Upload'" class="file-input" @change="selectFile" ref="file" type="file">
        <v-card-actions>
          <v-layout justify-center>
        <v-btn round color="primary" @click="uploadFileModal=false">Cancel</v-btn>
        <v-btn v-if="file&&uploadType==='Upload'" round color="primary" @click="uploadFile">Upload</v-btn>
        <v-btn v-if="uploadType==='URL'&&fileName!==''&&fileUrl!==''" round color="primary" @click="saveUrl">Save URL</v-btn>
        </v-layout>
        </v-card-actions>
      </v-card>
      
    </v-dialog>
    <v-dialog v-model="editFileModal" max-width="750px">
     
      <v-card flat color="white">
         <v-toolbar flat color="primary">
        <h1 class='headline white--text'>EDIT FILE</h1>
        
      </v-toolbar>
      <!-- <v-flex xs12 px-4 mx-4>
      <v-select v-model="editedItem.uploadType" label="Upload Type" :items="uploadTypes"></v-select>
      </v-flex> -->
      <v-flex xs12 px-4 mx-4 v-if="editedItem.uploadType==='URL'">
      <v-text-field  label="*File Name" v-model="editedItem.name"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="editedItem.uploadType!==''">
      <v-text-field  label="File Description" v-model="editedItem.description"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="editedItem.uploadType==='URL'">
      <v-text-field  label="*File URL" v-model="editedItem.fileUrl"></v-text-field>
      </v-flex>
      <br/>
        <!-- <input v-if="editedItem.uploadType==='Upload'" class="file-input" @change="selectFile" ref="file" type="file"> -->
        <v-card-actions>
          <v-layout justify-center>
        <v-btn round color="primary" @click="editFileModal=false">Cancel</v-btn>
        <v-btn v-if="editedItem.uploadType==='Upload'" round color="primary" @click="saveEditedItem">Save</v-btn>
        <v-btn v-if="editedItem.uploadType==='URL'&&editedItem.fileName!==''&&editedItem.fileUrl!==''" round color="primary" @click="saveEditedItem">Save</v-btn>
        </v-layout>
        </v-card-actions>
      </v-card>
      
    </v-dialog>
    </v-card>
        
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
props:['DocumentUpload','documents','locationid','deviceid','locationnetworkid','locationnodeid','customerid','contactid'],
data() {
    return {
        file:'',
        uploadFileModal:false,
        editFileModal: false,
        fileDescription:'',
        fileUrl:'',
        uploadType:'',
        fileName:'',
        fileUrl:'',
        uploadTypes:["Upload", "URL"],
        editedItem:{},
        documentHeaders:[
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
      },
        {
          text: "Description",
          align: "center",
          value: "description"
      }
      ]
}},
methods:{
     selectFile(event) {
    this.file = event.srcElement.files[0];
},
downloadFile(id){
  Api()
  .get('/upload/'+id)
  .then(response=>{
      let file = Buffer.from(response.data.base64, 'base64')
      const linkSource = `data:${response.data.type};base64,${response.data.base64}`;
    const downloadLink = document.createElement("a");
    const fileName = response.data.name;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  })
},
saveUrl(){
  let locationId=this.locationid
    let locationNetworkId= this.locationnetworkid
    let locationNodeId= this.locationnodeid
    let customerId= this.customerid
    let contactId= this.contactid
    let deviceId= this.devceid
    let description = this.fileDescription
    let fileUrl= this.fileUrl
    let name =this.fileName
  Api()
      .post('/upload',{
        description: description,
        name: name,
        isActive: true,
        isDeleted: false,
        locationId: locationId,
        locationNetworkId: locationNetworkId,
        locationNodeId: locationNodeId,
        deviceId: deviceId,
        customerId: customerId,
        contactId: contactId,
        fileUrl: fileUrl
      }).then(response=>{
        this.$emit('documentChange')
        this.uploadFileModal=false
      })
},
saveEditedItem(){
  Api()
    .put('/upload/'+this.editedItem.id,{
      description: this.editedItem.description,
        name: this.editedItem.name,
        isActive: true,
        isDeleted: false,
        locationId: this.editedItem.locationId,
        locationNetworkId: this.editedItem.locationNetworkId,
        locationNodeId: this.editedItem.locationNodeId,
        deviceId: this.editedItem.deviceId,
        customerId: this.editedItem.customerId,
        contactId: this.editedItem.contactId,
        fileUrl: this.editedItem.fileUrl,
    })
    .then(response=>{
      this.$emit('documentChange')
        this.editFileModal=false
    })
},
// async saveEditedUploadFile(){
  
//   var reader = new FileReader();
//     await reader.readAsBinaryString(this.file);
//     let file =''
//     let locationId=this.editedItem.locationId
//     let locationNetworkId= this.editedItem.locationNetworkId
//     let locationNodeId= this.editedItem.locationNodeId
//     let customerId= this.editedItem.customerId
//     let contactId= this.editedItem.contactId
//     let deviceId= this.editedItem.deviceId

//     let name =this.file.name
//     let type=this.file.type
//     let description = this.editedItem.fileDescription
//     let fileUrl= this.editedItem.fileUrl
//     reader.onload = await function() {
//         file=btoa(reader.result)
//         Api()
//       .post('/upload',{
//         description: description,
//         name: name,
//         type: type,
//         isActive: true,
//         isDeleted: false,
//         locationId: locationId,
//         locationNetworkId: locationNetworkId,
//         locationNodeId: locationNodeId,
//         deviceId: deviceId,
//         customerId: customerId,
//         contactId: contactId,
//         base64: file,
//         fileUrl: fileUrl,
//         type: type
//       })
      
//     };
//     this.$emit('documentChange')

//     reader.onerror = function() {
//         console.log('there are some problems');
//     };
      
//       this.uploadFileModal=false
// },
    async uploadFile(){
      var reader = new FileReader();
    await reader.readAsBinaryString(this.file);
    let file =''
    let locationId=this.locationid
    let locationNetworkId= this.locationnetworkid
    let locationNodeId= this.locationnodeid
    let customerId= this.customerid
    let contactId= this.contactid
    let deviceId= this.devceid

    let name =this.file.name
    let type=this.file.type
    let description = this.fileDescription
    let fileUrl= this.fileUrl
    reader.onload = await function() {
        file=btoa(reader.result)
        Api()
      .post('/upload',{
        description: description,
        name: name,
        type: type,
        isActive: true,
        isDeleted: false,
        locationId: locationId,
        locationNetworkId: locationNetworkId,
        locationNodeId: locationNodeId,
        deviceId: deviceId,
        customerId: customerId,
        contactId: contactId,
        base64: file,
        fileUrl: fileUrl,
        type: type
      })
      
    };
    this.$emit('documentChange')

    reader.onerror = function() {
        console.log('there are some problems');
    };
      
      this.uploadFileModal=false
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){ 
        this.uploadFileModal=true
      }
    },
    deleteFile(id){
      if(this.authDelete(this.$store.state.currentRoute)){ 
        confirm('Are you sure you would like to remove this file?')&&
        Api()
        .put('/upload/'+id,{
            iaActive: false,
            isDeleted: true
        }).then(response=>{
            this.$emit('documentChange')
        })
      }
    },
    editItem(item){
      if(this.authUpdate(this.$store.state.currentRoute)){ 
      this.editedItem = Object.assign({}, item);
      if(this.editedItem.base64!==null&&this.editedItem.base64!==''){
        this.editedItem.uploadType='Upload'
        this.file = Buffer.from(this.editedItem.base64, 'base64')
        // console.log(this.file)
      } else {
        this.editedItem.uploadType='URL'
      }
      this.editFileModal=true
    }}
}
}
</script>

<style>

</style>